import { always, mergeLeft } from 'ramda';
import actions from '../actions';
import { makeReducer } from '../utils';

export const INITIAL_STATE = {
  buttonLeft : undefined,
  buttonRight: undefined,
  content    : undefined,
  icon       : undefined,
  isOpen     : false,
  onClose    : undefined,
};

export default makeReducer({
  initialState: INITIAL_STATE,
  reducers    : {
    [actions.modal.close.type]: always(INITIAL_STATE),
    [actions.modal.open.type] : (state, { payload }) => mergeLeft({
      ...payload,
      isOpen: true,
    }, state),
  },
});
